// BbsInfoGql.js
import { gql } from "@apollo/client";


const BBS_INFO_LIST_PART = gql`
fragment BbsInfoListPart on BbsInfo {
    bbsTypeCd
    bbsInfoSeq
    dcCd
    dcName
    writer
    email
    title
    announceDate
    readCnt
    forAll
    popup
    popupStartAt
    popupEndAt
    popupDays
    popupNow
    topOrder
    boldTitle
    titleColor
    serverUrl
    fileAddr
    fileName1
    fileName2
    fileName3
    fileName4
    fileName5
    regUser
    regDate
    updatedDate
    updatedUser
}
`;

const BBS_INFO_NO_LIST_PART = gql`
fragment BbsInfoNoListPart on BbsInfo {
    content
}
`;


export const LIST_BBS_INFO = gql`
${BBS_INFO_LIST_PART}
query ListBbsInfo($bbsTypeCd:String!, $dateFrom:String, $dateTill:String) {
    bbsInfoList(bbsTypeCd:$bbsTypeCd, dateFrom:$dateFrom, dateTill:$dateTill) {
        ...BbsInfoListPart
    }
}
`;

export const GET_BBS_INFO = gql`
${BBS_INFO_LIST_PART}
${BBS_INFO_NO_LIST_PART}
query GetBbsInfo($bbsTypeCd:String!, $bbsInfoSeq:Int!) {
    bbsInfoItem(bbsTypeCd:$bbsTypeCd, bbsInfoSeq:$bbsInfoSeq) {
        ...BbsInfoListPart
        ...BbsInfoNoListPart
    }
}
`;

export const ADD_BBS_INFO = gql`
mutation AddBbsInfo($bbsInfo:InputBbsInfoAdd!) {
  bbsInfoAdd(bbsInfo: $bbsInfo) {
    ok
    message
    item {
        bbsTypeCd
        bbsInfoSeq
    }
  }
}
`;

export const EDIT_BBS_INFO = gql`
mutation EditBbsInfo($bbsInfo:InputBbsInfoEdit!) {
  bbsInfoEdit(bbsInfo: $bbsInfo) {
    ok
    message
  }
}
`;

export const REMOVE_BBS_INFO = gql`
mutation RemoveBbsInfo($bbsInfo:InputBbsInfoRemove!) {
  bbsInfoRemove(bbsInfo: $bbsInfo) {
    ok
    message
  }
}
`;

// 첨부파일 다운로드용 PreSigned URL 발급
export const GET_BBS_INFO_DOWNLOAD_URL_PRE_SIGNED = gql`
query GetBbsInfoDownloadUrlPreSigned($bbsTypeCd:String!, $bbsInfoSeq: Long!, $fileId: Int!) {
    bbsInfoGetDownloadUrlPreSigned(bbsTypeCd:$bbsTypeCd, bbsInfoSeq: $bbsInfoSeq, fileId: $fileId) {
        preSignedUrl
        objectKey
    }
}
`;

// 첨부파일 업로드용 PreSigned URL 발급
export const GET_BBS_INFO_UPLOAD_URL_PRE_SIGNED = gql`
query GetBbsInfoUploadUrlPreSigned($bbsTypeCd:String!, $bbsInfoSeq: Long!, $filename: String!, $contentType: String!) {
    bbsInfoGetUploadUrlPreSigned(bbsTypeCd:$bbsTypeCd, bbsInfoSeq: $bbsInfoSeq, filename: $filename, contentType: $contentType) {
        preSignedUrl
        objectKey
    }
}
`;

// bbsInfoGetUploadUrlPreSigned 사용해서 S3 첨부파일 올린 후 DB 기록.
export const ADD_BBS_INFO_FILE = gql`
mutation AddBbsInfoFile($bbsInfo: InputBbsInfoAddFile!) {
    bbsInfoAddFile(bbsInfo: $bbsInfo) {
        ok
        message
    }
}
`;

// 첨부 파일 삭제
export const REMOVE_BBS_INFO_FILE = gql`
mutation RemoveBbsInfoFile($bbsInfo: InputBbsInfoFileItem!) {
    bbsInfoRemoveFile(bbsInfo: $bbsInfo) {
        ok
        message
    }
}
`;

/*
# bbs_info.graphqls

extend type Query {
	bbsInfoList(bbsTypeCd:String!,dateFrom:String,dateTill:String): [BbsInfo]!
	bbsInfoItem(bbsTypeCd:String!,bbsInfoSeq:Int!): BbsInfo
    bbsInfoGetDownloadUrlPreSigned(bbsTypeCd:String!, bbsInfoSeq: Long!, fileId: Int!): S3Url
    bbsInfoGetUploadUrlPreSigned(bbsTypeCd:String!, bbsInfoSeq: Long!, filename: String!, contentType: String!): S3Url
}

extend type Mutation {
	bbsInfoAdd(bbsInfo: InputBbsInfoAdd!): ResponseWithBbsInfo
	bbsInfoEdit(bbsInfo: InputBbsInfoEdit!): CommonResponse
	bbsInfoRemove(bbsInfo: InputBbsInfoRemove!): CommonResponse
    bbsInfoAddFile(bbsInfo: InputBbsInfoAddFile!): CommonResponse
    bbsInfoRemoveFile(bbsInfo: InputBbsInfoFileItem!): CommonResponse
}

type BbsInfo {
	bbsTypeCd: String!
	bbsInfoSeq: Long!
	dcCd: String
    dcName: String
	writer: String
	email: String
	title: String!
	content: String
    announceDate: String
	readCnt: Int
	forAll: Boolean
	popup: Boolean
	popupStartAt: String
	popupEndAt: String
	popupDays: Int
    popupNow: Boolean
	topOrder: Boolean
	boldTitle: Boolean
	titleColor: Boolean
	serverUrl: String
	fileAddr: String
	fileName1: String
	fileName2: String
	fileName3: String
	fileName4: String
	fileName5: String
	regUser: String
	regDate: String
	updatedDate: String
	updatedUser: String
}

input InputBbsInfoAdd {
	bbsTypeCd: String!
	dcCd: String
	email: String
	title: String
	content: String
    announceDate: String
	forAll: Boolean
	popup: Boolean
	popupStartAt: String
	popupEndAt: String
	topOrder: Boolean
	boldTitle: Boolean
	titleColor: Boolean
}

input InputBbsInfoEdit {
	bbsTypeCd: String!
	bbsInfoSeq: Int!
	dcCd: String
	email: String
	title: String
	content: String
    announceDate: String
	forAll: Boolean
	popup: Boolean
	popupStartAt: String
	popupEndAt: String
	topOrder: Boolean
	boldTitle: Boolean
	titleColor: Boolean
}

input InputBbsInfoRemove {
	bbsTypeCd: String!
	bbsInfoSeq: Int!
}


type ResponseWithBbsInfo {
	ok: Boolean!
	message: String
	item: BbsInfo
}


# 2026.1.21
input InputBbsInfoAddFile {
    bbsTypeCd:String!
    bbsInfoSeq: Long!
    fileId: Int!
    fileName1: String!
}

# 2026.1.21
input InputBbsInfoFileItem {
    bbsTypeCd:String!
    bbsInfoSeq: Long!
    fileId: Int!
}

*/
